import React from "react";
import { Button, Container } from "react-bootstrap";
import "./Offer.css";
const Offer = () => {
  return (
    <div className="section-container offer-container">
      <Container fluid className="p-0">
        <div className="row">
          <div className="col-12 col-md-12 col-lg-6 col-xl-6 p-0">
            <div className="offer-main">
              <img
                src={require("../../../images/offer/offer-main.jpg")}
                alt=""
                className="h-100 w-100"
              />
              <div className="offer-main-text">
                <div className="text-center text-light">
                <h3>Save 20% Now</h3>
                  <p>Lorem ipsum dolor sit amet consectetur adipisicing.</p>
                  <Button className="btn-light">Get Now</Button>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-12 col-lg-6 col-xl-6 p-0">
            <div className="offer-grid">
              <div className="single-offer">
                <img
                  src={require("../../../images/offer/offer1.jpg")}
                  alt=""
                  className="h-100 w-100"
                />
                <div className="offer-main-text">
                  <div className="text-center text-light">
                    <h3>Save 20% Now</h3>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing.</p>
                    <Button className="btn-light">Get Now</Button>
                  </div>
                </div>
              </div>
              <div className="single-offer">
                <img
                  src={require("../../../images/offer/offer2.jpg")}
                  alt=""
                  className="h-100 w-100"
                />
                <div className="offer-main-text">
                  <div className="text-center text-light">
                  <h3>Save 20% Now</h3>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing.</p>
                    <Button className="btn-light">Get Now</Button>
                  </div>
                </div>
              </div>
              <div className="single-offer">
                <img
                  src={require("../../../images/offer/offer3.jpg")}
                  alt=""
                  className="h-100 w-100"
                />
                <div className="offer-main-text">
                  <div className="text-center text-light">
                  <h3>Save 20% Now</h3>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing.</p>
                    <Button className="btn-light">Get Now</Button>
                  </div>
                </div>
              </div>
              <div className="single-offer">
                <img
                  src={require("../../../images/offer/offer4.jpg")}
                  alt=""
                  className="h-100 w-100"
                />
                <div className="offer-main-text">
                  <div className="text-center text-light">
                  <h3>Save 20% Now</h3>
                    <p>Lorem ipsum dolor sit amet consectetur adipisicing.</p>
                    <Button className="btn-light">Get Now</Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Offer;
